import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export var useGetCompanyTemplates = function () {
    var intl = useIntl();
    return useQuery([SettingsQueryKey.CompanyTemplates], function () {
        return api.base
            .get('/api/Template/Company/')
            .then(function (res) { return res.data; });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
